<template>
  <div>
    <spinner
      v-if="loadingPage"
      style="display: block; margin: 0 auto"
    ></spinner>
    <div
      v-if="currentRecords"
      style="width: 100%; margin: 0px"
      :class="[...classes]"
    >
      <table
        v-if="table"
        style="width: 100%"
        class="display nowrap table table-hover table-striped table-bordered"
      >
        <thead>
          <slot name="thead"></slot>
        </thead>
        <tbody>
          <component
            :itemTemplateProps="itemTemplateProps"
            v-for="(item, index) in currentRecords.data"
            :index="index"
            :name="itemTemplate == 'course' ? item.code : item.id"
            :key="
              itemTemplate + (itemTemplate == 'course' ? item.code : item.id)
            "
            :is="itemComponent"
            @event="emitEvent"
            :item="item"
            :userId="userId && itemTemplate == 'media' ? userId : false"
            :userEntity="userEntity"
          ></component>
        </tbody>
      </table>
      <component
        :itemTemplateProps="itemTemplateProps"
        v-else
        v-for="(item, index) in currentRecords.data"
        :index="index"
        :name="itemTemplate == 'course' ? item.code : item.id"
        :key="itemTemplate + (itemTemplate == 'course' ? item.code : item.id)"
        :is="itemComponent"
        @event="emitEvent"
        :item="item"
        :isInline="isInline"
        :userId="userId && itemTemplate == 'media' ? userId : false"
        :userEntity="userEntity"
      ></component>
    </div>
    <div v-if="currentRecords && !loadingPage" class="row">
      <div
        v-if="currentRecords.per_page < currentRecords.total"
        class="col-md-12"
      >
        <nav v-if="currentRecords.last_page < 9" class="col-sm-12 text-center">
          <ul class="pagination justify-content-center">
            <li
              class="page-item"
              :class="{ disabled: !currentRecords.prev_page_url }"
            >
              <a
                class="page-link"
                href="javascript:void(0)"
                @click="changePage(currentRecords.current_page - 1)"
              >
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>
            <li
              v-for="n in currentRecords.last_page"
              class="page-item"
              :key="n"
              :class="{ active: currentRecords.current_page === n }"
            >
              <a
                @click="changePage(n)"
                class="page-link"
                href="javascript:void(0)"
                >{{ n }}</a
              >
            </li>
            <li
              class="page-item"
              :class="{ disabled: !currentRecords.next_page_url }"
            >
              <a
                @click="changePage(currentRecords.current_page + 1)"
                class="page-link"
                href="javascript:void(0)"
                aria-label="Next"
              >
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>
          </ul>
        </nav>
        <div
          v-else-if="currentRecords.last_page < 16"
          class="text-center p-10"
          style="font-size: 0"
        >
          <a
            :style="
              'border-bottom-' +
              right +
              '-radius: 0; box-shadow: none; border-top-' +
              right +
              '-radius: 0; border-' +
              right +
              ': none; vertical-align: top;'
            "
            v-if="currentRecords.prev_page_url"
            class="btn btn-secondary"
            :class="{ disabled: !currentRecords.prev_page_url }"
            href="javascript:void(0)"
            @click="changePage(currentRecords.current_page - 1)"
          >
            <span aria-hidden="true">&laquo;</span>
            <span class="sr-only">Previous</span>
          </a>
          <div style="display: inline-block; position: relative">
            <div style="display: inline-block; position: relative">
              <select
                class="custom-select slk"
                @change="goToPage()"
                v-model="selectedPage"
              >
                <option
                  :value="n"
                  v-for="n in currentRecords.last_page"
                  :key="n"
                >
                  <a @click="changePage(n)" href="javascript:void(0)">{{
                    n
                  }}</a>
                </option>
              </select>
              <font
                class="mdi mdi-menu-down"
                style="
                  pointer-events: none;
                  position: absolute;
                  top: 0px;
                  bottom: 0px;
                  right: 0px;
                  font-size: 16px;
                  line-height: 40px;
                "
              >
              </font>
            </div>
            <div
              :style="
                'display: inline-block; line-height: 36px; font-weight: 400; height: 40px; padding-' +
                right +
                ': 14px; padding-' +
                left +
                ': 4px; color: #333; font-size: 15px; vertical-align: top; background: #fff; border: 1px solid #b1b8bb; border-' +
                left +
                ': none;'
              "
            >
              {{ $t("data.of") }} {{ currentRecords.last_page }}
            </div>
          </div>
          <a
            :style="
              'border-bottom-' +
              left +
              '-radius: 0; box-shadow: none; border-top-' +
              left +
              '-radius: 0; border-' +
              left +
              ': none; vertical-align: top;'
            "
            v-if="currentRecords.next_page_url"
            class="btn btn-secondary"
            :class="{ disabled: !currentRecords.next_page_url }"
            @click="changePage(currentRecords.current_page + 1)"
            href="javascript:void(0)"
            aria-label="Next"
          >
            <span aria-hidden="true">&raquo;</span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import { mapState } from "vuex";
import * as ItemTemplates from "../Layouts/Items";
import Spinner from "vue-simple-spinner";
import { EventBus } from "../../event-bus";
import Vue from "vue";
export default {
  props: [
    "data",
    "itemTemplate",
    "currentPage",
    "classes",
    "userId",
    "userEntity",
    "table",
    "isInline",
    "itemTemplateProps",
  ],
  data() {
    return {
      msg: "hello vue",
      currentRecords: null,
      url: null,
      selectedPage: 1,
      itemComponent: null,
      loadingPage: false,
    };
  },
  components: { Spinner },
  created() {
    EventBus.$on("pagination:changePage", this.changePageListener);
    EventBus.$on("pagination:table:updateRow", (newRowItem) => {
      var rowIndex = this.currentRecords.data.findIndex(
        (rowItem) => rowItem.id == newRowItem.id
      );
      if (newRowItem.deleted) {
        this.currentRecords.data.splice(rowIndex, 1);
      } else {
        Vue.set(this.currentRecords.data, rowIndex, newRowItem);
      }
    });
    this.itemComponent = ItemTemplates[this.itemTemplate];
    this.currentRecords = this.data;
    this.url = this.currentRecords.first_page_url || null;
    if (this.url) {
      this.url = this.url.split("page=");
    }
    if (this.$route.query[this.itemTemplate + "Page"]) {
      this.changePage(this.$route.query[this.itemTemplate + "Page"]);
    }
    this.loadingPage = false;
    this.$emit("loadingPageChange", this.loadingPage);
  },
  methods: {
    changePage(page) {
      let self = this;
      this.loadingPage = true;
      self.currentRecords = [];
      this.$http.get(this.url[0] + "page=" + page + "&result_mode=2").then((res) => {
        // console.log("res");
        // console.log(res);
        if (res.body.hasOwnProperty("data")) {
          self.currentRecords = res.body; // sometimes the remote function is returning the data directly in the body
        } else if (res.body.results.hasOwnProperty("first_page_url")) {
          self.currentRecords = res.body.results; // sometimes in a results object
        } else {
          self.currentRecords =
            res.body.results[Object.keys(res.body.results)[0]]; // sometimes in an object in the results object
        }

        self.loadingPage = false;
        self.selectedPage = page;
        self.$emit("updateCurrentPage", page);
        var pageKey = self.itemTemplate + "Page";
        var query = {};
        query[pageKey] = page;
        self.$router.push({ query: query });
      });
    },
    goToPage() {
      this.changePage(this.selectedPage);
    },
    emitEvent(event) {
      this.$emit(event.name, event.payload);
    },
    changePageListener(newPage) {
      if (newPage == this.selectedPage) {
        return;
      }
      this.changePage(newPage);
    },
  },
  watch: {
    data(val) {
      if (val && val.data) {
        this.currentRecords = val;
        this.url = val.next_page_url || val.last_page_url || null;
        if (this.url) {

          this.url = this.url.split("page=");
          if (this.currentPage != 1 && this.currentPage != undefined) {
            this.changePage(this.currentPage);
          } else if (this.$route.query[this.itemTemplate + "Page"]) {
            this.changePage(this.$route.query[this.itemTemplate + "Page"]);
          }
        }
      }
    },
    itemTemplate() {
      this.itemComponent = ItemTemplates[this.itemTemplate];
    },
    loadingPage() {
      this.$emit("loadingPageChange", this.loadingPage);
    },
  },
  beforeDestroy() {
    EventBus.$off("pagination:changePage", this.changePageListener);
  },
};
</script>
<style lang="scss" scoped>
.pagination > .page-item > .page-link {
  background-color: #0056b3;
}
.custom-select.slk {
  display: inline-block;
  vertical-align: top;
  box-shadow: none;
  padding: 0 10px 0 14px;
  width: auto;
  border: 1px solid #b1b8bb;
  border-right: none;
  height: 40px;
  border-radius: 0;
  background: #fff;
  cursor: pointer;
  font-size: 15px;
  text-align: center;
  z-index: 4;

  &:hover {
    background: #f2f4f8;
    color: #0056b3;
  }
}

.rtl .custom-select.slk {
  display: inline-block;
  vertical-align: top;
  box-shadow: none;
  padding: 0 14px 0 10px;
  width: auto;
  border: 1px solid #b1b8bb;
  border-left: none;
  height: 40px;
  border-radius: 0;
  background: #fff;
  cursor: pointer;
  font-size: 15px;
  text-align: center;
  z-index: 4;

  &:hover {
    background: #f2f4f8;
    color: #0056b3;
  }
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/common/Pagination.vue